import React, {useRef, useMemo, useEffect, useState} from 'react'
import {useSelector, useDispatch} from "react-redux";
import {useHistory, useParams, useLocation} from "react-router-dom";
import GenericImageMap from './generic_image_map'
import {HotspotPreview} from "./hotspot_preview";
import CustomCss from "./custom_css";
import {useTracking} from "../effects/use_tracking";
import {sendTrackingData} from  'src/shared/database_actions.jsx'
import {ImageMapProvider} from "./image_map_provider";
import {Liquid} from "liquidjs";
import renderTag from "./rendered_html_content/additional_tags/render";

const isInitiallyOpenHotspot = (imageHotspot) => {
  return imageHotspot?.data?.supportChatData?.showInitially == "true" || imageHotspot?.data?.supportChatData?.showInitially == true
}

const AdditionalHotspotPreviews = ({closedInitialOpenHotspotIds, setClosedInitialOpenHotspotIds, imageMap}) => {
  const additionalHotspots = useSelector(state => state.imageHotspots.filter(imageHotspot => {
    return imageHotspot.image_map_id === imageMap.id && !closedInitialOpenHotspotIds.includes(imageHotspot.id) && isInitiallyOpenHotspot(imageHotspot) // (imageHotspot?.data?.supportChatData?.showInitially == "true" || imageHotspot?.data?.supportChatData?.showInitially == true)
  }))

  return <>
    {additionalHotspots.map(imageHotspot => {
      return <HotspotPreview
        hotspot={imageHotspot}
        key={imageHotspot.id}
        id={imageHotspot.id}
        kind={imageHotspot.kind}
        data={imageHotspot.data}
        imageMap={imageMap}

        onModalClose={() => {
          setClosedInitialOpenHotspotIds([
            ...closedInitialOpenHotspotIds,
            imageHotspot.id
          ])
        }}/>
    })}
  </>
}

const useLiquidParams = (initialPlaceholders) => {
  const tagOwner = useSelector(state => state.tagOwner)
  const htmlContents = useSelector(state => state.htmlContents || [])
  const events = useSelector(state => state.events)
  const videoRooms = useSelector(state => state.videoRooms);

  // Eigentlich gar nicht wirklich nötig weil die engin da eh nicht erstelt wird aber maybe bringts irgendwann mal was ...
  return useMemo(() => {
    // Duplicate them
    let placeholders = JSON.parse(JSON.stringify(initialPlaceholders || {}))

    if (tagOwner) {
      if (!placeholders.tagOwner) {
        placeholders.tagOwner = tagOwner
      }
      if (!placeholders.tag_owner) {
        placeholders.tag_owner = tagOwner
      }
    }

    if (!placeholders.events) {
      placeholders.events = events
    }

    if (!placeholders.htmlContents) {
      placeholders.htmlContents = htmlContents
    }

    if (!placeholders.videoRooms) {
      placeholders.videoRooms = videoRooms
    }

    return placeholders
  }, [
    JSON.stringify(initialPlaceholders),
    htmlContents,
    events,
    videoRooms,
  ])
}

export default function ImageMap({preselectedHotspot, clearPreselectedHotspot, onModalClose, ...props}) {
  const track = useTracking()
  const history = useHistory();
  const {id} = useParams();
  const location = useLocation();
  const hostname = useSelector(state => state.hostname)
  const dispatch = useDispatch()
  const tagOwner = useSelector(state => state.tagOwner)
  const isBoothEditor = useSelector(state => state.isBoothEditor)
  const imageMapConfigs = useSelector((state) => state.imageMapConfigs)
  const imageMaps = useSelector((state) => state.imageMaps)
  const imageMap = props.imageMap || imageMaps.find((im) => im.id == id)
  const accountOrganization = useSelector(state => state.accountOrganizations.find(accountOrganization => accountOrganization.id == imageMap.account_organization_id))

  const [hotspotId, setHotspotId] = useState(null)
  const [currentSlideshowImageId, setCurrentSlideshowImageId] = useState(null)
  const [closedInitialOpenHotspotIds, setClosedInitialOpenHotspotIds] = useState([])

  const hotspot = useSelector(state => state.imageHotspots.find(h => h.id === hotspotId))
  const selectedHotspotViaConfigId = imageMap.config_data?.preselectedHotspotId
  const selectedHotspotConfigIdentifierViaConfigId = imageMap.config_data?.preselectedHotspotConfigIdentifier
  const selectedHotspotViaConfig = useSelector(state => selectedHotspotViaConfigId ? state.imageHotspots.find(h => h.id === selectedHotspotViaConfigId) : null)
  const selectedHotspotViaConfigIdentifier = useSelector(state => selectedHotspotConfigIdentifierViaConfigId ? state.imageHotspots.find(h => state.imageHotspotConfigs.find(hc => hc.id == h.image_hotspot_config_id)?.identifier === selectedHotspotConfigIdentifierViaConfigId) : null)
  const selectedSlideshowImage = useSelector(state => state.imageHotspotSlideshowImages.find(si => si.id === currentSlideshowImageId))
  const liquidParams = useLiquidParams({imageMap})

  let currentKind = hotspot?.kind
  let currentData = hotspot?.data
  let currentId = hotspot?.id

  const finalPreselectedHotspot = preselectedHotspot || selectedHotspotViaConfig || selectedHotspotViaConfigIdentifier


  if (hotspot?.kind === "slideshow") {
    currentId = selectedSlideshowImage?.id || currentId
    currentKind = selectedSlideshowImage?.data?.kind || currentKind
    currentData = selectedSlideshowImage?.data || currentData
  }

  useEffect(() => {
    if(finalPreselectedHotspot) {
      onHotspotClick(finalPreselectedHotspot)
      if (clearPreselectedHotspot) {
        clearPreselectedHotspot()
      }
    }
  }, [finalPreselectedHotspot, onHotspotClick, clearPreselectedHotspot])

  const onHotspotClick = (hotspot, currentSlideshowImage, hotspotConfig) => {
    setHotspotId(hotspot?.id)
    setCurrentSlideshowImageId(currentSlideshowImage?.id)

    let data = hotspot.data
    let kind = hotspot?.kind

    if (hotspot?.kind === "slideshow") {
      data = currentSlideshowImage.data
      kind = data?.kind
    }

    if (isInitiallyOpenHotspot(hotspot)) {
      setClosedInitialOpenHotspotIds(closedInitialOpenHotspotIds.filter(closedHotSpotId => closedHotSpotId != hotspot.id))
    }



    //console.log("CLICK", {kind, data});
    switch (kind) {
      case "redirect":
        if (data?.redirect_url) {
          const engine = new Liquid()
          engine.registerTag("render_html", renderTag)

          let parsedRedirectUrl = data?.redirect_url
          try {
            //const tpl = engine.parse(html)
            parsedRedirectUrl = engine.parseAndRenderSync(data?.redirect_url, liquidParams)
          } catch (ex) {
            alert("Error parsing redirect url: ", data?.redirect_url)
            console.error(ex, "placeholders", liquidParams)
          }

          if(props.disableTracking == undefined && hotspot) {
            const imageMapConfig = imageMapConfigs?.find(im => im.id == hotspotConfig?.image_map_config_id)
            const imageMap = imageMaps?.find(im => im.id == hotspot.image_map_id)
            const googleAnalyticsData = `${imageMap?.title} (${imageMapConfig?.title}) > ${hotspot?.title} (${hotspotConfig?.title}) - URL: ${parsedRedirectUrl}`
            track("hotspot_click", {hotspot_id: hotspot.id, slideshowImageId: currentSlideshowImage?.id, description: parsedRedirectUrl}, {event_label: googleAnalyticsData})
            // console.debug("TRACKING")
          }

          if(hostname == "flaveueg20" && [407, 408, 409, 410, 411, 413].find((item) => item == hotspot?.id)) {
            console.warn("Opening UEG Player in the same window for hotspot", hotspot)
            window.location = parsedRedirectUrl.replace(/@tag_owner_id@/g, tagOwner ? tagOwner.id : "")
          } else {
            if (data?.redirect_in_same_window === "true" || data?.redirect_in_same_window === true) {
              dispatch(sendTrackingData()).finally(() => {
                window.location = parsedRedirectUrl.replace(/@tag_owner_id@/g, tagOwner ? tagOwner.id : "")
              })
            } else {
              window.open(parsedRedirectUrl.replace(/@tag_owner_id@/g, tagOwner ? tagOwner.id : ""), '_blank');
            }
          }
        }
        break;
      case "image_map_id":
        if(props.disableTracking == undefined && hotspot) {
          const imageMapConfig = imageMapConfigs?.find(im => im.id == hotspotConfig?.image_map_config_id)
          const imageMap = imageMaps?.find(im => im.id == hotspot.image_map_id)
          const googleAnalyticsData = `${imageMap?.title} (${imageMapConfig?.title}) > ${hotspot?.title} (${hotspotConfig?.title})`
          track("hotspot_click", {hotspot_id: hotspot.id, slideshowImageId: currentSlideshowImage?.id}, {event_label: googleAnalyticsData})
        }
        history.push("/image_map/" + data.image_map_redirect_id);
        break;
      case "inline_html":
        console.debug("not tracking due to kind == inline_html")
        break;
      default:
        if(props.disableTracking == undefined && hotspot) {
          const imageMapConfig = imageMapConfigs?.find(im => im.id == hotspotConfig?.image_map_config_id)
          const imageMap = imageMaps?.find(im => im.id == hotspot.image_map_id)
          const googleAnalyticsData = `${imageMap?.title} (${imageMapConfig?.title}) > ${hotspot?.title} (${hotspotConfig?.title})`
          track("hotspot_click", {hotspot_id: hotspot.id, slideshowImageId: currentSlideshowImage?.id}, {event_label: googleAnalyticsData})
        }
    }
  }

  const handleOnModalClose = () => {
    if (hostname == "flavemedkarriere20" && location.pathname.endsWith(hotspotId.toString())) {
      history.push(location.pathname.replace(new RegExp(`${hotspotId}$`), ''))
    }
    setHotspotId(null)
    setCurrentSlideshowImageId(null)
    if (onModalClose) {
      onModalClose();
    }
  }

  if(!imageMap.active) {
    return <div className="alert alert-danger">This view is currently not available.</div>
  }

  return <ImageMapProvider imageMap={imageMap}>
    <CustomCss accountOrganization={accountOrganization}/>

    {!isBoothEditor && <AdditionalHotspotPreviews closedInitialOpenHotspotIds={closedInitialOpenHotspotIds} setClosedInitialOpenHotspotIds={setClosedInitialOpenHotspotIds} imageMap={imageMap} />}

    {hotspot && currentId && currentKind && !isInitiallyOpenHotspot(hotspot) &&
      <HotspotPreview
        hotspot={hotspot}
        key={currentId}
        id={currentId}
        kind={currentKind}
        data={currentData}
        imageMap={imageMap}

        onModalClose={handleOnModalClose}/>
    }
    <GenericImageMap 
      imageMap={imageMap}
      onHotspotClick={onHotspotClick} />
  </ImageMapProvider>
}
